import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container } from './common/styles';
import { defaultProfileCompleteness, profileCompletenessType } from './headers-components/score';
import HeaderWrapper from './headers-components/wrapper';
import TrendingControl from './trending-control';
import FollowOptionsControl from './follow-options-control';
import NotificationsControl from './notifications-control';

export default function EmailPreferencesControl({
  profileCompleteness,
  followFrequenciesToUpdate,
  subscribedToTrending,
  tolSubscriptionOptions,
  notifyOnFollowOptions,
  notifyOnLikeOptions,
  notifyOnCommentOptions,
  notifyOnMentionOptions,
  isContributorOrEditor,
  newNavEnabled,
  weeklyTOLEnabled,
}) {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });

  return (
    <ThemeProvider theme={{ ...theme, isMobile }}>
      <HeaderWrapper title="Email preferences" profileCompleteness={profileCompleteness} newNavEnabled={newNavEnabled} />
      <Container>
        <TrendingControl
          subscribedToTrending={subscribedToTrending}
          weeklyTOLEnabled={weeklyTOLEnabled}
          tolSubscriptionOptions={tolSubscriptionOptions}
        />
        <FollowOptionsControl
          options={notifyOnFollowOptions}
          frequenciesToUpdate={followFrequenciesToUpdate}
        />
        {
          isContributorOrEditor && (
            <NotificationsControl
              notifyOnLikeOptions={notifyOnLikeOptions}
              notifyOnCommentOptions={notifyOnCommentOptions}
              notifyOnMentionOptions={notifyOnMentionOptions}
            />
          )
        }
      </Container>
    </ThemeProvider>
  );
}

EmailPreferencesControl.propTypes = {
  profileCompleteness: profileCompletenessType,
  followFrequenciesToUpdate: PropTypes.arrayOf(PropTypes.string),
  subscribedToTrending: PropTypes.bool.isRequired,
  tolSubscriptionOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnFollowOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnLikeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnCommentOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  notifyOnMentionOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  isContributorOrEditor: PropTypes.bool.isRequired,
  newNavEnabled: PropTypes.bool,
  weeklyTOLEnabled: PropTypes.bool,
};

EmailPreferencesControl.defaultProps = {
  profileCompleteness: defaultProfileCompleteness,
  followFrequenciesToUpdate: null,
  newNavEnabled: false,
  weeklyTOLEnabled: false,
};
